import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';


import { lookupStatusPropType } from '../../../propTypes';
import LookupStatusIcon from './LookupStatusIcon';


const propTypes = exact({
  item: PropTypes.shape({
    lookupStatus: lookupStatusPropType.isRequired,
    name: PropTypes.string.isRequired,
  }),
});


const LookupResultListItem = (props) => {
  const { item: { lookupStatus, name } } = props;

  // NOTE: div tag used over fragment as this is embedded in a list
  return (
    <div>
      <LookupStatusIcon lookupStatus={lookupStatus} />
      {' '}
      { name }
    </div>
  );
};


LookupResultListItem.propTypes = propTypes;


export default LookupResultListItem;
